<div class="bg-white">
  <div style="position: relative;">
    <button (click)="markAdvertisingAsReadForCurrentUserAndClose()" class="close-button" type="button" optim-actions="markAdvertisingAsRead">
      <span aria-hidden="true" class="c-white">&times;</span>
    </button>
  </div>
  <div [style.background-image]="'url(' + this.advertising.fileBackground + ')'" class="advertising-image d-block">
    <div class="columns small-12">
      <div class="margin-v-xl"
           style="align-items: center">
        <h1>
          <div [innerHTML]="this.advertising.titleHtml | safeHtml"></div>
        </h1>
      </div>
    </div>
    <div *ngIf="advertising.chapeauHtml && advertising.chapeauHtml !== null" class="columns small-12 margin-b-l">
      <div class="card-padding"
           style="align-items: center; text-align: left">
        <h2>
          <div [innerHTML]="this.advertising.chapeauHtml | safeHtml"></div>
        </h2>
      </div>
    </div>
    <div class="columns small-12 margin-b-l">
      <div class="card-padding"
           style="align-items: center; text-align: left">
        <h3>
          <div [innerHTML]="this.advertising.textHtml | safeHtml"></div>
        </h3>
      </div>
    </div>
    <div class="columns small-12 margin-v-l">
      <a (click)="redirectToLink()"
         *ngIf="this.advertising.actionBtLabel !== '' && this.advertising.actionBtLabel !== null && this.advertising.actionBtLabel !== undefined"
         class="button large insito">
          <span [title]="this.advertising.actionBtLabel">
            {{this.advertising.actionBtLabel}}
          </span>
      </a>
    </div>
  </div>
</div>
